export const FACADE_HOSTNAME = 'www.uprightproject.com';
export const FACADE_URL = `https://${FACADE_HOSTNAME}`;
